export default __webpack_public_path__ + "static/media/menos.179f9b07.svg";